/**
 * CKEditor 5 Configuration
 *
 * Contains default configuration for the editor including:
 * - Toolbar items
 * - Language settings
 * - Image configuration
 * - Table configuration
 * - And more...
 */

import { uploadAdapterPlugin } from './upload-adapter';

export const EDITOR_TOOLBAR_ITEMS = [
	'removeFormat',
	'heading',
	'style',
	'|',
	'bold',
	'italic',
	'underline',
	'horizontalLine',
	'strikethrough',
	'superscript',
	'subscript',
	'link',
	'highlight',
	'|',
	'fontBackgroundColor',
	'fontColor',
	'fontFamily',
	'fontSize',
	'alignment',
	'|',
	'numberedList',
	'bulletedList',
	'outdent',
	'indent',
	'|',
	'imageUpload',
	'imageInsert',
	'blockQuote',
	'insertTable',
	'mediaEmbed',
	'htmlEmbed',
	'showBlocks',
	'selectAll',
	'pageBreak',
	'specialCharacters',
	'code',
	'codeBlock',
	'sourceEditing',
	'|',
	'undo',
	'redo',
] as const;

export const HEADING_OPTIONS = [
	{ model: 'paragraph', title: 'Văn bản', class: 'ck-heading_paragraph' },
	{ model: 'heading2', view: 'h2', title: 'Tiêu đề 2', class: 'ck-heading_heading2' },
	{ model: 'heading3', view: 'h3', title: 'Tiêu đề 3', class: 'ck-heading_heading3' },
	{ model: 'heading4', view: 'h4', title: 'Tiêu đề 4', class: 'ck-heading_heading4' },
] as const;

export const IMAGE_TOOLBAR = [
	'imageStyle:alignLeft',
	'imageStyle:alignCenter',
	'imageStyle:alignRight',
	'|',
	'imageResize:50',
	'imageResize:75',
	'imageResize:original',
	'|',
	'linkImage',
	'imageTextAlternative',
	'toggleImageCaption',
] as const;

export const IMAGE_RESIZE_OPTIONS = [
	{
		name: 'imageResize:original',
		value: null,
		icon: 'original',
	},
	{
		name: 'imageResize:50',
		value: '50',
		icon: 'medium',
	},
	{
		name: 'imageResize:75',
		value: '75',
		icon: 'large',
	},
] as const;

export const IMAGE_STYLES = ['full', 'alignLeft', 'alignRight', 'side', 'alignCenter'] as const;

export const TABLE_CONTENT_TOOLBAR = [
	'tableColumn',
	'tableRow',
	'mergeTableCells',
	'tableCellProperties',
	'tableProperties',
] as const;

export function getEditorConfig(
	placeholder?: string,
	customConfig?: Record<string, unknown>
): Record<string, unknown> {
	return {
		extraPlugins: [uploadAdapterPlugin],
		placeholder: placeholder || 'Nhập nội dung...',
		language: 'vi',
		heading: {
			options: [...HEADING_OPTIONS],
		},
		image: {
			toolbar: [...IMAGE_TOOLBAR],
			resizeOptions: [...IMAGE_RESIZE_OPTIONS],
			styles: {
				options: [...IMAGE_STYLES]
			},
		},
		table: {
			contentToolbar: [...TABLE_CONTENT_TOOLBAR],
		},
		...customConfig,
	};
}
